import { Fragment, useState } from "react";
import ImportStudentFromCSV from "../Components/ImportDataFromCSV";
import { exportToExcel } from "../Components/ExportStatisticPartyYouth";
import { Box, Button, colors, Dialog, DialogContent, DialogTitle, FormControl, Grid, IconButton, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { formatPhone } from "../Function/DynamicFn";
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DoneIcon from '@mui/icons-material/Done';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import StraightIcon from '@mui/icons-material/Straight';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
// 

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  fontSize: "14px",
  marginTop: "20px",
};

const thTdStyle = {
  border: "1px solid #ddd",
  padding: "6px",
};

const headerStyle = {
  background: "#1976d2",
  color: "white",
  fontWeight: "bold",
  fontFamily: "Khmer OS Siemreap",
};


export default function PopulationList() {

    const [CSVData,setCSVData] = useState([]);
    const [loadingData,setLoadingData] = useState(false);
    const [view,setView] = useState("ListImport");
    const [dataInvalid,setDataInvalid] = useState([]);
    const [showRowUpdate,setShowRowUpdate] = useState("");
    const [valueUpdate,setValueUpdate] = useState();
    const [hover, setHover] = useState({ status: false , row: "" });
    const [noValeForDelete,setNoValeForDelete] = useState("");
    // console.log("CSVData:::::", CSVData);
    const [count,setCount] = useState(0);
    const [fieldName,setFieldName] = useState("");
    const [findValue,setFindValue] = useState("");
    const [replaceValue,setReplaceValue] = useState("");
    const [sortField,setSortField] = useState("no");
    
    // Delete
    const [open,setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    // Find Replace
    const [openFindReplace,setOpenFindReplace] = useState(false);
    const handleOpenFindReplace = () => setOpenFindReplace(true);
    const handleCloseFindReplace = () => {
        setOpenFindReplace(false);
        setCount(0); 
        setFindValue("");
        setReplaceValue("");
    }

    // 
    const handleExportData = () => {

        if(CSVData?.length > 0) {
            // console.log(CSVData[0]["លរ.\nNO."]);

            let myData = CSVData?.map((d) => { 
                if(
                    d["លរ.\nNO."] &&
                    d["គោត្តនាមនិងនាម\nName of household"]                    
                ) {                 
                    return { 
                        no: d["លរ.\nNO."],
                        Nameofhousehold: d["គោត្តនាមនិងនាម\nName of household"],
                        NameofhouseholdLatin: formatNameLatin(d["គោត្តនាមនិងនាម\nName of household\n( La Tinh)"]),
                        Village: d["ភូមិ\nHamlet"],
                        VillageLatin: formatNameLatin(d["ភូមិ\nHamlet\n( La Tinh)"]),
                        Commune: d["ឃុំ\nCommune\n"],
                        CommuneLatin: formatNameLatin(d["ឃុំ\nCommune\n( La Tinh)"]),
                        District: d["ស្រុក\nDistrict"],
                        DistrictLatin: formatNameLatin(d["ស្រុក\nDistrict\n( La Tinh)"]),
                        Province: d["ខេត្ត\nProvince"],
                        ProvinceLatin: formatNameLatin(d["ខេត្ត\nProvince\n( La Tinh)"]),
                        NumberPhone: formatPhone(d["លេខទូរស័ព្ទ\nNumber Phone"]),
                        Note: d["ផ្សេងៗ\nNote"],
                    };
                }
            })?.filter( e => e !== undefined ) || [];

            // console.log("myData::::", myData);

            // Export Data
            exportToExcel(myData)

        } 
    }


    // 
    // Helper functions
    function hasKhmerSpace(name) {
        return /\s/.test(name);
    }

    function hasLatinSpace(name) {
        return /\s/.test(name);
    }

    function isTitleCase(name) {
        if (!name) return true;
        return name
            .split(" ")
            .every(word => /^[A-Z][a-z]+$/.test(word));
    }

    // Main validation function
    function validateHousehold(data) {
        const duplicateKh = new Map();
        const duplicateLatin = new Map();
        const duplicatePhone = new Map();
        const errors = [];

        // 1️⃣ Count duplicates
        data.forEach(row => {
            const kh = row.Nameofhousehold?.trim();
            const latin = row.NameofhouseholdLatin?.trim();
            const phone = row.NumberPhone?.trim();

            duplicateKh.set(kh, (duplicateKh.get(kh) || 0) + 1);
            duplicateLatin.set(latin, (duplicateLatin.get(latin) || 0) + 1);

            if (phone) {
                duplicatePhone.set(phone, (duplicatePhone.get(phone) || 0) + 1);
            }
        });

        // 2️⃣ Validate each row
        data.forEach(row => {
            const rowErrors = [];
            const kh = row.Nameofhousehold?.trim();
            const latin = row.NameofhouseholdLatin?.trim();
            const phone = row.NumberPhone?.trim();

            // Duplicate checks
            if (duplicateKh.get(kh) > 1) rowErrors.push("Duplicate Khmer Name");
            if (duplicateLatin.get(latin) > 1) rowErrors.push("Duplicate Latin Name");
            if (phone && duplicatePhone.get(phone) > 1)
                rowErrors.push("Duplicate Phone Number");

            // ✅ Missing phone number
            if (!phone || phone === "") {
                rowErrors.push("No Phone Number");
            }

            // Spacing checks
            if (kh && !hasKhmerSpace(kh)) rowErrors.push("Khmer name missing space");
            if (latin && !hasLatinSpace(latin)) rowErrors.push("Latin name missing space");

            // Capitalization check
            // if (latin && !isTitleCase(latin))
            //     rowErrors.push("Latin name not Title Case");

            // Include row if there are errors
            if (rowErrors.length > 0) {
                errors.push({
                    ...row,
                    issues: rowErrors
                });
            }
        });

        return errors;
    }


    function formatNameLatin(name) {
        if (!name) return "";

        return name
            .toLowerCase()
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    }

     

    const handleSortByNo = (val) => {
        // 
        let valueFilter = val ? val : dataInvalid;
        // 
        const sortedResult = [...valueFilter].sort((a, b) => {
            return a.no - b.no;
        });

        setDataInvalid(sortedResult);
    };

    const handleSortByKhmerName = (val) => {
        // 
        let valueFilter = val ? val : dataInvalid;
        // 
        const sortedResult = valueFilter.sort((a, b) => {
        if (!a.Nameofhousehold) return -1;
        if (!b.Nameofhousehold) return 1;

        return a.Nameofhousehold.localeCompare(b.Nameofhousehold, 'km'); 
        // 'km' = Khmer locale
        });

        setDataInvalid(sortedResult); 
    }

    const handleSortByLatinName = (val) => {
        // 
        let valueFilter = val ? val : dataInvalid;
        // 
        const sortedResult = [...valueFilter].sort((a, b) => {
            const nameA = a.NameofhouseholdLatin?.trim() || "";
            const nameB = b.NameofhouseholdLatin?.trim() || "";

            return nameA.localeCompare(nameB); // default locale for Latin letters
        });

        setDataInvalid(sortedResult);
    };

    const handleSortDuplicatePhone = (val) => {
        // 
        let valueFilter = val ? val : dataInvalid;
        // 
        const phoneCount = {};

        // count phones
        valueFilter.forEach(row => {
            const phone = row.NumberPhone?.trim();
            if (phone) {
            phoneCount[phone] = (phoneCount[phone] || 0) + 1;
            }
        });

        const sorted = [...valueFilter].sort((a, b) => {
            const aPhone = a.NumberPhone?.trim();
            const bPhone = b.NumberPhone?.trim();

            const aDuplicate = phoneCount[aPhone] > 1;
            const bDuplicate = phoneCount[bPhone] > 1;

            // duplicates first
            if (aDuplicate && !bDuplicate) return -1;
            if (!aDuplicate && bDuplicate) return 1;

            // then sort by phone number
            return (aPhone || "").localeCompare(bPhone || "");
        });

        setDataInvalid(sorted);
    };

    const handleCheckValidation = (CSVDataFilter) => {
        // 
        let myData = CSVDataFilter?.map((d) => { 
                if(
                    d["លរ.\nNO."] &&
                    d["គោត្តនាមនិងនាម\nName of household"]                    
                ) {                 
                    return { 
                        no: d["លរ.\nNO."],
                        Nameofhousehold: d["គោត្តនាមនិងនាម\nName of household"],
                        NameofhouseholdLatin: formatNameLatin(d["គោត្តនាមនិងនាម\nName of household\n( La Tinh)"]),
                        Village: d["ភូមិ\nHamlet"],
                        VillageLatin: formatNameLatin(d["ភូមិ\nHamlet\n( La Tinh)"]),
                        Commune: d["ឃុំ\nCommune\n"],
                        CommuneLatin: formatNameLatin(d["ឃុំ\nCommune\n( La Tinh)"]),
                        District: d["ស្រុក\nDistrict"],
                        DistrictLatin: formatNameLatin(d["ស្រុក\nDistrict\n( La Tinh)"]),
                        Province: d["ខេត្ត\nProvince"],
                        ProvinceLatin: formatNameLatin(d["ខេត្ត\nProvince\n( La Tinh)"]),
                        NumberPhone: formatPhone(d["លេខទូរស័ព្ទ\nNumber Phone"]),
                        Note: d["ផ្សេងៗ\nNote"],
                    };
                }
            })?.filter( e => e !== undefined ) || [];

        const result = validateHousehold(myData); 
        setDataInvalid(result);  

        
        // ============ sort ==============
        if(sortField === "no") {
            handleSortByNo(result);
        }

        if(sortField === "nameKh") {
            handleSortByKhmerName(result);
        }

        if(sortField === "nameEn") {
            handleSortByLatinName(result);
        }

        if(sortField === "phone") {
            handleSortDuplicatePhone(result)
        } 
        // 
         
    }


    const handleUpdate = (noRow) => {
        const newA = CSVData.map(d =>
        d["លរ.\nNO."] === noRow
            ?   { 
                    ...d, 
                    ["គោត្តនាមនិងនាម\nName of household"]: valueUpdate?.Nameofhousehold,
                    ["គោត្តនាមនិងនាម\nName of household\n( La Tinh)"]: valueUpdate?.NameofhouseholdLatin,
                    ["ភូមិ\nHamlet"]: valueUpdate?.Village,
                    ["ភូមិ\nHamlet\n( La Tinh)"]: valueUpdate?.VillageLatin,
                    ["ឃុំ\nCommune\n"]: valueUpdate?.Commune,
                    ["ឃុំ\nCommune\n( La Tinh)"]: valueUpdate?.CommuneLatin,
                    ["ស្រុក\nDistrict"]: valueUpdate?.District,
                    ["ស្រុក\nDistrict\n( La Tinh)"]: valueUpdate?.DistrictLatin,
                    ["ខេត្ត\nProvince"]: valueUpdate?.Province,
                    ["ខេត្ត\nProvince\n( La Tinh)"]: valueUpdate?.ProvinceLatin,
                    ["លេខទូរស័ព្ទ\nNumber Phone"]: valueUpdate?.NumberPhone,
                    ["ផ្សេងៗ\nNote"]: valueUpdate?.Note, 
                }
            : d
        ); 
                        
        // 
        setCSVData(newA);
        handleCheckValidation(newA);
        setShowRowUpdate("");
    }
    
    
    const handleCountValueField = (CSVDataFilter, fieldName, value) => {      
        // 
        let count = 0;
        CSVDataFilter.map((d,index) => { 
            // 
            if (fieldName === "Village" && d["ភូមិ\nHamlet"] === value) {
                count += 1;
            } 
            if (fieldName === "VillageLatin" && formatNameLatin(d["ភូមិ\nHamlet\n( La Tinh)"]) === value) {
                count += 1;
            }

            if (fieldName === "Commune" && d["ឃុំ\nCommune\n"] === value) {
                count += 1;
            } 
            if (fieldName === "CommuneLatin" && formatNameLatin(d["ឃុំ\nCommune\n( La Tinh)"]) === value) {
                count += 1;
            }

            if (fieldName === "District" && d["ស្រុក\nDistrict"] === value) {
                count += 1;
            } 
            if (fieldName === "DistrictLatin" && formatNameLatin(d["ស្រុក\nDistrict\n( La Tinh)"]) === value) {
                count += 1;
            }

            if (fieldName === "Province" && d["ខេត្ត\nProvince"] === value) {
                count += 1;
            } 
            if (fieldName === "ProvinceLatin" && formatNameLatin(d["ខេត្ត\nProvince\n( La Tinh)"]) === value) {
                count += 1;
            } 
        }); 
        // 
        // console.log("count::::", count);
        setCount(count);
    }

    const handleFindAndReplaceAll = (CSVDataFilter, fieldName, oldValue, newValue) => {
        const newCSVData = CSVDataFilter.map((d) => {             

            if (fieldName === "Village" && d["ភូមិ\nHamlet"] === oldValue) {
                return {
                    ...d,
                    ["ភូមិ\nHamlet"]: newValue,
                };
            } 
            if (fieldName === "VillageLatin" && formatNameLatin(d["ភូមិ\nHamlet\n( La Tinh)"]) === oldValue) {
                return {
                    ...d,
                    ["ភូមិ\nHamlet\n( La Tinh)"]: newValue,
                };
            }

            if (fieldName === "Commune" && d["ឃុំ\nCommune\n"] === oldValue) {
                return {
                    ...d,
                    ["ឃុំ\nCommune\n"]: newValue,
                };
            } 
            if (fieldName === "CommuneLatin" && formatNameLatin(d["ឃុំ\nCommune\n( La Tinh)"]) === oldValue) {
                return {
                    ...d,
                    ["ឃុំ\nCommune\n( La Tinh)"]: newValue,
                };
            }

            if (fieldName === "District" && d["ស្រុក\nDistrict"] === oldValue) {
                return {
                    ...d,
                    ["ស្រុក\nDistrict"]: newValue,
                };
            } 
            if (fieldName === "DistrictLatin" && formatNameLatin(d["ស្រុក\nDistrict\n( La Tinh)"]) === oldValue) {
                return {
                    ...d,
                    ["ស្រុក\nDistrict\n( La Tinh)"]: newValue,
                };
            }

            if (fieldName === "Province" && d["ខេត្ត\nProvince"] === oldValue) {
                return {
                    ...d,
                    ["ខេត្ត\nProvince"]: newValue,
                };
            } 
            if (fieldName === "ProvinceLatin" && formatNameLatin(d["ខេត្ត\nProvince\n( La Tinh)"]) === oldValue) {
                return {
                    ...d,
                    ["ខេត្ត\nProvince\n( La Tinh)"]: newValue,
                };
            }  
            // 
            return d;
        });

        // 
        // console.log("newCSVData::::", newCSVData);
        setCSVData(newCSVData);
        handleCheckValidation(newCSVData);
        handleCloseFindReplace();
    }


    const handleDeleteData = () => {
        if (!noValeForDelete) return;

        // Keep only items where NO. is not the one to delete
        const newA = CSVData.filter(d => d["លរ.\nNO."] !== noValeForDelete);

        setCSVData(newA);
        handleCheckValidation(newA);
        setShowRowUpdate("");
        setNoValeForDelete("");
        handleClose();
    };


    return(
        <div
            style={{
                padding: "0px 10px 10px 10px"
            }}
        >
            <Stack
                direction={"column"}
                justifyContent={"center"}
                sx={{
                    width: "100%",
                    backgroundColor: "rgb(25, 118, 210)",
                    height: "40px"
                }}
            >   
                <Typography 
                    sx={{
                        fontFamily: "Khmer OS Siemreap", 
                        color: "#fff"
                    }}
                >
                    ប្រព័ន្ធត្រួតពិនិត្យបញ្ជីឈ្មោះប្រជាជន
                </Typography>
            </Stack>

            <Grid container spacing={2} marginTop={1}> 
                <Grid item xs={4}>
                    <Stack direction={"column"} justifyContent={"center"} height="100%">
                        <Typography 
                            sx={{
                                fontFamily: "Khmer OS Siemreap", 
                            }}
                        >
                            បញ្ជូលទិន្នន័យ (File CSV)៖
                        </Typography>
                    </Stack>
                </Grid>
                <Grid item xs={4}>
                    <ImportStudentFromCSV 
                        open={false}
                        setCSVData={setCSVData}
                        setLoadingData={setLoadingData}
                    />
                </Grid>
                <Grid item xs={2}>
                    
                </Grid>
            </Grid>
            
            <Grid container spacing={2} marginTop={3}>
                <Grid item md={6}>
                    <Stack direction={"row"} spacing={1}>
                        <Button  
                            onClick={() => setView("ListImport")}
                            className={"btn-export"} 
                            // startIcon={<ExitToAppIcon />}  
                            sx={{
                                background: view === "ListImport" ? "#1976d2 !important" : "#fff !important",
                                color:  view !== "ListImport" ? "#1976d2 !important" : "#fff !important",
                                fontFamily: "Khmer OS Siemreap",
                            }}
                        >
                            ទិន្នន័យប្រជាជន
                        </Button>
                        <Button  
                            onClick={() => setView("DataInvalid")}
                            className={"btn-export"} 
                            // startIcon={<ExitToAppIcon />}  
                            sx={{
                                background: view === "DataInvalid" ? "#1976d2 !important" : "#fff !important",
                                color:  view !== "DataInvalid" ? "#1976d2 !important" : "#fff !important",
                                fontFamily: "Khmer OS Siemreap",
                            }}
                        >
                            ទិន្នន័យមានបញ្ហា
                        </Button>
                    </Stack> 
                </Grid>

                <Box flexGrow={1} />

                <Grid item md={6}>
                    <Stack direction={"row"} spacing={1}>
                        <Button  
                            onClick={() => handleOpenFindReplace()}
                            className={"btn-export"} 
                            // startIcon={<ExitToAppIcon />} 
                            sx={{ 
                                fontFamily: "Khmer OS Siemreap", 
                                backgroundColor: "orange",
                                color: "#fff"
                            }}
                        >
                            Find & Replace
                        </Button>

                        {
                            view === "ListImport" &&
                            <Button  
                                onClick={() => handleExportData()}
                                className={"btn-export"} 
                                // startIcon={<ExitToAppIcon />} 
                                sx={{ 
                                    fontFamily: "Khmer OS Siemreap", 
                                    backgroundColor: "green",
                                    color: "#fff"
                                }}
                            >
                                Export Excel
                            </Button>
                        }
                        
                        {
                            view === "DataInvalid" &&
                            <Button  
                                onClick={() => handleCheckValidation(CSVData)}
                                className={"btn-export"} 
                                // startIcon={<ExitToAppIcon />} 
                                sx={{ 
                                    fontFamily: "Khmer OS Siemreap", 
                                    backgroundColor: "green",
                                    color: "#fff"
                                }}
                            >
                                Check Data
                            </Button> 
                        } 
                    </Stack>
                </Grid>
            </Grid>

                         
            <table style={tableStyle}>

                <thead>
                    <tr>
                        <th style={{ ...thTdStyle, ...headerStyle }}>     
                            <Stack direction={"row"} justifyContent={"center"}>
                                <Stack direction={"column"} justifyContent={"center"}>
                                    ល.រ
                                </Stack>
                                <IconButton
                                    onClick={() => {
                                        handleSortByNo();
                                        setSortField("no");
                                    }}
                                >   
                                    <StraightIcon style={{ fontSize: "15px" , color: "#fff"}}/>
                                </IconButton>
                            </Stack>
                        </th>
                        <th style={{ ...thTdStyle, ...headerStyle }}>
                            <Stack direction={"row"} justifyContent={"center"}>
                                <Stack direction={"column"} justifyContent={"center"}>
                                    ឈ្មោះ (Kh)
                                </Stack>
                                <IconButton
                                    onClick={() => {
                                        handleSortByKhmerName();
                                        setSortField("nameKh");
                                    }}
                                >   
                                    <StraightIcon style={{ fontSize: "15px" , color: "#fff"}}/>
                                </IconButton>
                            </Stack>                        
                        </th>
                        <th style={{ ...thTdStyle, ...headerStyle }}> 
                            <Stack direction={"row"} justifyContent={"center"}>
                                <Stack direction={"column"} justifyContent={"center"}>
                                    Name (Latin)
                                </Stack>
                                <IconButton
                                    onClick={() => {
                                        handleSortByLatinName();
                                        setSortField("nameEn");
                                    }}
                                >   
                                    <StraightIcon style={{ fontSize: "15px" , color: "#fff"}}/>
                                </IconButton>
                            </Stack> 
                        </th>
                        <th style={{ ...thTdStyle, ...headerStyle }}>Village</th>
                        <th style={{ ...thTdStyle, ...headerStyle }}>Village Latin</th>
                        <th style={{ ...thTdStyle, ...headerStyle }}>Commune</th>
                        <th style={{ ...thTdStyle, ...headerStyle }}>Commune Latin</th>
                        <th style={{ ...thTdStyle, ...headerStyle }}>District</th>
                        <th style={{ ...thTdStyle, ...headerStyle }}>District Latin</th>
                        <th style={{ ...thTdStyle, ...headerStyle }}>Province</th>
                        <th style={{ ...thTdStyle, ...headerStyle }}>Province Latin</th>
                        <th style={{ ...thTdStyle, ...headerStyle }}> 
                            <Stack direction={"row"} justifyContent={"center"}>
                                <Stack direction={"column"} justifyContent={"center"}>
                                    Phone
                                </Stack>
                                <IconButton
                                    onClick={() => {
                                        handleSortDuplicatePhone();
                                        setSortField("phone");
                                    }}
                                >   
                                    <StraightIcon style={{ fontSize: "15px" , color: "#fff"}}/>
                                </IconButton>
                            </Stack> 
                        </th>
                        <th style={{ ...thTdStyle, ...headerStyle }}>Note</th>
                        <th style={{ ...thTdStyle, ...headerStyle }}></th>
                    </tr>
                </thead>

                {
                    view === "ListImport" ?
                    <tbody>
                        { CSVData?.length > 0 && CSVData?.map((d, index) => (
                            <tr key={index}>
                                <td style={{ fontFamily: "Khmer OS Siemreap", }} >{d["លរ.\nNO."]}</td>
                                <td style={{ fontFamily: "Khmer OS Siemreap", }} >{d["គោត្តនាមនិងនាម\nName of household"]}</td>
                                <td style={{ fontFamily: "Khmer OS Siemreap", }} >{formatNameLatin(d["គោត្តនាមនិងនាម\nName of household\n( La Tinh)"])}</td>
                                <td style={{ fontFamily: "Khmer OS Siemreap", }} >{d["ភូមិ\nHamlet"]}</td>
                                <td style={{ fontFamily: "Khmer OS Siemreap", }} >{d["ភូមិ\nHamlet\n( La Tinh)"]}</td>
                                <td style={{ fontFamily: "Khmer OS Siemreap", }} >{d["ឃុំ\nCommune\n"]}</td>
                                <td style={{ fontFamily: "Khmer OS Siemreap", }} >{d["ឃុំ\nCommune\n( La Tinh)"]}</td>
                                <td style={{ fontFamily: "Khmer OS Siemreap", }} >{d["ស្រុក\nDistrict"]}</td>
                                <td style={{ fontFamily: "Khmer OS Siemreap", }} >{d["ស្រុក\nDistrict\n( La Tinh)"]}</td>
                                <td style={{ fontFamily: "Khmer OS Siemreap", }} >{d["ខេត្ត\nProvince"]}</td>
                                <td style={{ fontFamily: "Khmer OS Siemreap", }} >{d["ខេត្ត\nProvince\n( La Tinh)"]}</td>
                                <td style={{ fontFamily: "Khmer OS Siemreap", }} >{formatPhone(d["លេខទូរស័ព្ទ\nNumber Phone"])}</td>
                                <td style={{ fontFamily: "Khmer OS Siemreap", }} >{d["ផ្សេងៗ\nNote"]}</td> 
                            </tr>
                        ))}
                    </tbody>
                :
                    <tbody>
                        { dataInvalid?.length > 0 && dataInvalid?.map( (d, index) => (
                        <Fragment key={index}>
                            <tr
                                onMouseEnter={() => setHover({status: true , row: d?.no })}
                                onMouseLeave={() => setHover({status: false , row: "" })}
                                style={{
                                    backgroundColor: hover?.status && hover?.row === d?.no ? "#f1f1f1" : "transparent",
                                    cursor: "pointer",
                                }}
                            > 
                                <td style={{ fontFamily: "Khmer OS Siemreap", }}>{d?.no}</td>
                                <td 
                                    style={{ 
                                        fontFamily: "Khmer OS Siemreap",
                                        color: d?.issues?.includes("Duplicate Khmer Name") || 
                                                    d?.issues?.includes("Khmer name missing space")  ? "red" : "black" 
                                    }}
                                >
                                    {d?.Nameofhousehold}
                                </td>
                                <td 
                                    style={{ 
                                        fontFamily: "Khmer OS Siemreap",
                                        color:  d?.issues?.includes("Latin name not Title Case") || 
                                                    d?.issues?.includes("Duplicate Latin Name") || 
                                                    d?.issues?.includes("Latin name missing space") ? "red" : "black" 
                                    }}
                                >
                                    {formatNameLatin(d?.NameofhouseholdLatin)}
                                </td>
                                <td style={{ fontFamily: "Khmer OS Siemreap", }}>{d?.Village}</td>
                                <td style={{ fontFamily: "Khmer OS Siemreap", }}>{d?.VillageLatin}</td>
                                <td style={{ fontFamily: "Khmer OS Siemreap", }}>{d?.Commune}</td>
                                <td style={{ fontFamily: "Khmer OS Siemreap", }}>{d?.CommuneLatin}</td>
                                <td style={{ fontFamily: "Khmer OS Siemreap", }}>{d?.District}</td>
                                <td style={{ fontFamily: "Khmer OS Siemreap", }}>{d?.DistrictLatin}</td>
                                <td style={{ fontFamily: "Khmer OS Siemreap", }}>{d?.Province}</td>
                                <td style={{ fontFamily: "Khmer OS Siemreap", }}>{d?.ProvinceLatin}</td>
                                <td 
                                    style={{ 
                                        fontFamily: "Khmer OS Siemreap",
                                        color: d?.issues?.includes("Duplicate Phone Number") ? "red" : "black",
                                        backgroundColor:  d?.issues?.includes("No Phone Number") ? "red" : '',
                                        // formart number each company
                                        // wrong digit                                         
                                    }}
                                >
                                    {formatPhone(d?.NumberPhone)}
                                </td>
                                <td>{d?.Note}</td> 
                                <td style={{ width: "20px", padding: 0 }}>
                                
                                    {
                                        showRowUpdate !== d?.no &&
                                        <Stack direction="row" spacing={0.5}> 
                                            <Button
                                                size="small"
                                                sx={{
                                                    minWidth: 0,
                                                    width: 24,
                                                    height: 24,
                                                    padding: 0,
                                                    backgroundColor: "orange",
                                                }}
                                                onClick={ () => {
                                                    setShowRowUpdate(d?.no);
                                                    setValueUpdate(d);
                                                }}
                                            >
                                                <EditIcon sx={{ color: "#fff", fontSize: 14 }} />
                                            </Button>

                                            <Button
                                                size="small"
                                                sx={{
                                                    minWidth: 0,
                                                    width: 24,
                                                    height: 24,
                                                    padding: 0,
                                                    backgroundColor: "red",
                                                }}
                                                onClick={() => {
                                                    setNoValeForDelete(d?.no);
                                                    handleOpen();
                                                }}
                                            >
                                                <DeleteOutlineIcon sx={{ color: "#fff", fontSize: 14 }} />
                                            </Button>

                                        </Stack>
                                    } 
                                </td>
                            </tr>
                        
                            {
                                showRowUpdate === d?.no && 
                                <tr> 
                                    <td style={{ fontFamily: "Khmer OS Siemreap", }}>
                                        <IconButton>
                                            <SubdirectoryArrowRightIcon sx={{ color: "orange" }}/>
                                        </IconButton>
                                    </td>
                                    <td>
                                        {/* {d?.Nameofhousehold} */}
                                        <TextField 
                                            size="small"
                                            fullWidth 
                                            value={valueUpdate?.Nameofhousehold}
                                            onChange={(e) => setValueUpdate({ ...valueUpdate, Nameofhousehold: e.target.value })}
                                        />
                                    </td>
                                    <td>
                                        {/* {d?.NameofhouseholdLatin} */}
                                        <TextField 
                                            size="small"
                                            fullWidth 
                                            value={valueUpdate?.NameofhouseholdLatin}
                                            onChange={(e) => setValueUpdate({ ...valueUpdate, NameofhouseholdLatin: e.target.value })}
                                        />
                                    </td>
                                    <td>
                                        {/* {d?.Village} */}
                                        <TextField 
                                            size="small"
                                            fullWidth 
                                            value={valueUpdate?.Village}
                                            onChange={(e) => setValueUpdate({ ...valueUpdate, Village: e.target.value })}
                                        />
                                    </td>
                                    <td>
                                        {/* {d?.VillageLatin} */}
                                        <TextField 
                                            size="small"
                                            fullWidth 
                                            value={valueUpdate?.VillageLatin}
                                            onChange={(e) => setValueUpdate({ ...valueUpdate, VillageLatin: e.target.value })}
                                        />
                                    </td>
                                    <td>
                                        {/* {d?.Commune} */}
                                        <TextField 
                                            size="small"
                                            fullWidth 
                                            value={valueUpdate?.Commune}
                                            onChange={(e) => setValueUpdate({ ...valueUpdate, Commune: e.target.value })}
                                        />
                                    </td>
                                    <td>
                                        {/* {d?.CommuneLatin} */}
                                        <TextField 
                                            size="small"
                                            fullWidth 
                                            value={valueUpdate?.CommuneLatin}
                                            onChange={(e) => setValueUpdate({ ...valueUpdate, CommuneLatin: e.target.value })}
                                        />
                                    </td>
                                    <td>
                                        {/* {d?.District} */}
                                        <TextField 
                                            size="small"
                                            fullWidth 
                                            value={valueUpdate?.District}
                                            onChange={(e) => setValueUpdate({ ...valueUpdate, District: e.target.value })}
                                        />
                                    </td>
                                    <td>
                                        {/* {d?.DistrictLatin} */}
                                        <TextField 
                                            size="small"
                                            fullWidth 
                                            value={valueUpdate?.DistrictLatin}
                                            onChange={(e) => setValueUpdate({ ...valueUpdate, DistrictLatin: e.target.value })}
                                        />                                    
                                    </td>
                                    <td>
                                        {/* {d?.Province} */}
                                        <TextField 
                                            size="small"
                                            fullWidth 
                                            value={valueUpdate?.Province}
                                            onChange={(e) => setValueUpdate({ ...valueUpdate, Province: e.target.value })}
                                        /> 
                                    </td>
                                    <td>
                                        {/* {d?.ProvinceLatin} */}
                                        <TextField 
                                            size="small"
                                            fullWidth 
                                            value={valueUpdate?.ProvinceLatin}
                                            onChange={(e) => setValueUpdate({ ...valueUpdate, ProvinceLatin: e.target.value })}
                                        /> 
                                    </td>
                                    <td>
                                        {/* {formatPhone(d?.NumberPhone)} */}
                                        <TextField 
                                            size="small"
                                            fullWidth 
                                            value={valueUpdate?.NumberPhone}
                                            onChange={(e) => setValueUpdate({ ...valueUpdate, NumberPhone: e.target.value })}
                                        />
                                    </td>
                                    <td>
                                        {/* {d?.Note} */}
                                        <TextField 
                                            size="small"
                                            fullWidth 
                                            value={valueUpdate?.Note}
                                            onChange={(e) => setValueUpdate({ ...valueUpdate, Note: e.target.value })}
                                        />
                                    </td> 
                                    <td style={{ width: "20px", padding: 0 }}>
                                        <Stack direction="row" spacing={0.5}>
                                            
                                            <Button
                                                size="small"
                                                sx={{
                                                    minWidth: 0,
                                                    width: 24,
                                                    height: 24,
                                                    padding: 0,
                                                    backgroundColor: "green",
                                                }}
                                                onClick={() => handleUpdate(d?.no)}
                                            >
                                                <DoneIcon sx={{ color: "#fff", fontSize: 14 }} />
                                            </Button>

                                            <Button
                                                size="small"
                                                sx={{
                                                    minWidth: 0,
                                                    width: 24,
                                                    height: 24,
                                                    padding: 0,
                                                    backgroundColor: "red",
                                                }}
                                                onClick={() => setShowRowUpdate("")}
                                            >
                                                <CloseIcon sx={{ color: "#fff", fontSize: 14 }} />
                                            </Button>

                                        </Stack>
                                    </td>
                                </tr>
                            }
                        </Fragment>
                        ))}
                    </tbody>
                }
                
            </table>
 
            
            {/* ============  Dialog Delete =============== */}
            <Dialog open={openFindReplace} className="dialog-container" fullWidth maxWidth="sm">
                <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
                    <Stack direction="row" justifyContent="space-between">
                        <Stack direction="column" justifyContent="center">
                            <Typography 
                                sx={{
                                    fontFamily: 'Khmer OS Siemreap'
                                }}
                            >
                             ស្វែងរក និង កែប្រែទិន្នន័យ
                            </Typography>
                        </Stack>
                        <Stack direction="column" justifyContent="center">
                            <IconButton onClick={handleCloseFindReplace}>
                                <DoNotDisturbOnIcon sx={{ color: "red" }} />                                
                            </IconButton>
                        </Stack>
                    </Stack>
                </DialogTitle>

                <DialogContent dividers>

                    <Stack direction={"row"} spacing={2}>
                        <Typography sx={{ fontFamily: "Khmer OS Siemreap" , alignContent: "center" , width: '35%' }}>
                            Column Name:
                        </Typography>
                        <FormControl fullWidth className="search-field" size="small" >
                            <Select
                                value={fieldName}
                                onChange={(e) => setFieldName(e?.target.value)}
                            >  
                                <MenuItem value={"Village"}>Village</MenuItem>
                                <MenuItem value={"VillageLatin"}>VillageLatin</MenuItem>
                                <MenuItem value={"Commune"}>Commune</MenuItem>
                                <MenuItem value={"CommuneLatin"}>CommuneLatin</MenuItem>
                                <MenuItem value={"District"}>District</MenuItem>
                                <MenuItem value={"DistrictLatin"}>DistrictLatin</MenuItem>
                                <MenuItem value={"Province"}>Province</MenuItem>
                                <MenuItem value={"ProvinceLatin"}>ProvinceLatin</MenuItem>
                            </Select>
                        </FormControl>
                        <Box width={"20%"}>

                        </Box>
                    </Stack>

                    <Stack direction={"row"} spacing={2} mt={1}>
                        <Typography sx={{ fontFamily: "Khmer OS Siemreap" , alignContent: "center" , width: '35%' }}>
                            Find What:
                        </Typography>
                        <TextField
                            fullWidth
                            size="small"
                            value={findValue}
                            onChange={(e) => setFindValue(e.target.value)}
                        />
                        <Button 
                            onClick={() => handleCountValueField(CSVData, fieldName , findValue) }
                            sx={{
                                width: "20%",
                                backgroundColor: "rgb(25, 118, 210)"
                            }}
                        >
                            <Typography sx={{ color: "#fff" , fontFamily: "Khmer OS Siemreap" }}>
                                Find
                            </Typography>                   
                        </Button>
                    </Stack>

                    <Stack direction={"row"} spacing={2} mt={1}>
                        <Typography sx={{ fontFamily: "Khmer OS Siemreap" , alignContent: "center" , width: '35%' }}>
                             
                        </Typography>
                        <Typography>Found: {count || 0}</Typography>
                        <Box width={"20%"}>

                        </Box>
                    </Stack>


                    <Stack direction={"row"} spacing={2} mt={1}>
                        <Typography sx={{ fontFamily: "Khmer OS Siemreap" , alignContent: "center" , width: '35%' }}>
                            Replace with:
                        </Typography>
                        <TextField
                            fullWidth
                            size="small"
                            value={replaceValue}
                            onChange={(e) => setReplaceValue(e.target.value)}
                        />
                        <Button 
                            onClick={() => handleFindAndReplaceAll(CSVData, fieldName , findValue , replaceValue) }
                            disabled={replaceValue ? false : true}
                            sx={{
                                width: "20%",
                                backgroundColor: "rgb(25, 118, 210)"
                            }}
                        >
                            <Typography sx={{ color: "#fff" , fontFamily: "Khmer OS Siemreap" }}>
                                Replace
                            </Typography>                   
                        </Button>
                    </Stack> 

                </DialogContent>

            </Dialog> 
            {/* ============  Dialog Delete =============== */}


            {/* ============  Dialog Delete =============== */}
            <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
                <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
                    <Stack direction="row" justifyContent="space-between">
                        <Stack direction="column" justifyContent="center">
                            <Typography 
                                sx={{
                                    fontFamily: 'Khmer OS Siemreap'
                                }}
                            >
                             លុបទិន្នន័យ
                            </Typography>
                        </Stack>
                        <Stack direction="column" justifyContent="center">
                            <IconButton onClick={handleClose}>
                                <DoNotDisturbOnIcon sx={{ color: "red" }} />                                
                            </IconButton>
                        </Stack>
                    </Stack>
                </DialogTitle>

                <DialogContent dividers>
                    <Stack direction={"row"} justifyContent={"space-between"}>
                        <Typography sx={{ fontFamily: "Khmer OS Siemreap" }}>
                            តើអ្នកពីតជាចង់លុបទិន្នន័យនេះមែនទេ?
                        </Typography>
                    </Stack>
                    <Stack direction={"row"} justifyContent={"space-between"} marginTop={2}>
                        <Stack direction="row" justifyContent="center" width={"100%"} spacing={2}>
                            <Button 
                                onClick={handleClose}
                                sx={{
                                    width: "50%",
                                    backgroundColor: "rgb(25, 118, 210)"
                                }}
                            >
                                <Typography sx={{ color: "#fff" , fontFamily: "Khmer OS Siemreap" }}>ទេ</Typography>                   
                            </Button>
                        
                            <Button 
                                onClick={handleDeleteData}
                                sx={{
                                    width: "50%",
                                    backgroundColor: "red"
                                }}
                            >
                                <Typography sx={{ color: "#fff" , fontFamily: "Khmer OS Siemreap" }}>លុប</Typography>                   
                            </Button>

                        </Stack>
                    </Stack>
                </DialogContent>

            </Dialog> 
            {/* ============  Dialog Delete =============== */}

        </div>
    )
}